export const theme = {
  colors: {
    main: '#FFF',
    mainAlternate: '#3A4555',
    landlord: {
      main: '#D2007E',
      mainAlternate: '#CA0079',
      mainPale: '#FFF6FC',
    },
    neutral: {
      main: '#394555',
      mainAlternate: '#313D4D',
    },
    tenant: {
      main: '#029D9D',
      mainAlternate: '#008888',
      mainPale: '#E8FFFF',
    },
    cross: {
      arancin: '#FF7400',
      brightSun: '#FFC101',
      black: '#1D1D1D',
      deepBlu: '#394555',
      greenMint: '#1DD699',
      red: '#EB5757',
      grayson: '#757575',
      silverFox: '#C8C8C8',
      lightGray: '#E5E5E5',
      ultralightGray: '#FBFBFB',
    },
    gradients: {
      main: 'linear-gradient(to right, rgba(255, 0, 153, 1.0) 10%, rgba(67, 71, 165) 55%, rgba(2, 157, 157, 1.0) 85%)',
      alternate: 'linear-gradient(75.1deg, #DEF3F3 20.54%, #FBE6F3 80.48%)',
    },
  },
  fonts: {
    body: `Nunito, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif`,
  },
  layers: {
    bottomBar: 900,
    createProperty: 1000,
    header: 1000,
    modal: 1100,
    mobileNavBody: 1000,
  },
  breakpoints: {
    xs: '320px', // min-width: 320px Small Mobile-portrait (and larger)
    s: '480px', // min-width: 480px	Mobile-landscape (and larger)
    m: '768px', // min-width: 768px Tablet-portrait (and larger)
    l: '992px', // min-width: 992px	Tablet-landscape (and larger)
    xl: '1200px', // min-width: 1200px Laptops (and larger)
    xxl: '1600px', // min-width: 1600px The whole Universe (and larger)
  },
  spacings: {
    none: '0px',
    xxs: '4px',
    xs: '8px',
    s: '16px',
    m: '24px',
    l: '48px',
    xl: '96px',
  },
  sizes: {
    phi: 1.61803398875,
  },
  gridsystem: {
    cols: 8,
  },
};
